import JobDetailPage from './JobDetailPage';

export default JobDetailPage;
